import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { fetchProducts } from "../lib/api";
import { ProductCard } from "../components/ProductCard";

const FILTERS = [
  { id: "all", label: "Усі" },
  { id: "bikini", label: "Бікіні" },
  { id: "one-piece", label: "Суцільні" },
];

export default function Products() {
  const [params, setParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const filter = params.get("category") || "all";

  useEffect(() => {
    fetchProducts().then(setProducts).catch(console.error);
  }, []);

  const swimwear = products.filter((p) => p.category !== "care");
  const visible = filter === "all" ? swimwear : swimwear.filter((p) => p.category === filter);

  return (
    <div data-testid="products-page">
      {/* Header */}
      <section className="bg-silea-cream border-b border-stone-200">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 pt-16 pb-12">
          <p className="eyebrow text-silea-navy/60">Колекція 2026</p>
          <h1 className="font-serif-display text-5xl sm:text-7xl mt-4 text-silea-navy leading-[1.05]">
            Riviera
          </h1>
          <p className="mt-4 max-w-xl text-silea-navy/70">
            Кожна модель — це окрема мелодія італійського узбережжя. Знайдіть свою.
          </p>

          <div className="mt-10 flex items-center gap-3 flex-wrap">
            {FILTERS.map((f) => (
              <button
                key={f.id}
                data-testid={`filter-${f.id}`}
                onClick={() => {
                  if (f.id === "all") setParams({});
                  else setParams({ category: f.id });
                }}
                className={`eyebrow px-5 py-2 border transition-colors ${
                  filter === f.id
                    ? "bg-silea-navy text-white border-silea-navy"
                    : "bg-transparent text-silea-navy border-stone-300 hover:border-silea-navy"
                }`}
              >
                {f.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Grid */}
      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16">
        {visible.length === 0 ? (
          <p className="py-24 text-center text-silea-navy/60">Завантаження...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-14">
            {visible.map((p) => (
              <ProductCard key={p.id} product={p} />
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
